import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { FlexBox, FullWidth, Section } from "./DualMenu.style";

import { useBreak } from "hooks/useBreak";
import { getFocus, useAtom, useGet } from "state/jotai";

import { _bootstrap } from "state/store.bootstrap";

import {
  current_language,
  currentActiveProject,
  params_query,
} from "state/store.global";

import {
  getIsoData,
  getLowIsoData,
  setIsoData,
} from "state/jotai.isometryDataHooks";

import { Icon } from "assets/Icons_";

import { Controls } from "components/Isometry/Isometry.Controls";
import { ArrowButton } from "components/Isometry/Isometry.Controls.Arrows.style";

import { SelectFunction } from "components/SelectFunction/SelectFunction";
import { ShiftProperty } from "components/ShiftProperty/ShiftProperty";

import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { Status } from "components/StatusPopup/StatusPopup";

import EusButton, { ETStyledButton } from "components/Button/EusButton";
import { useToggle } from "hooks/useToggle";
import { useRotation } from "hooks/useRotation";
import { useState } from "react";
import { isIframeMode } from "logging/logging";
import CommoIframenMenus from "components/Iframe/commonMenus";


export const IsometryDualMenu = ({
  left,
  right,
  nav,

  pin,
  pid,

  clickList,
  clickModel,
  toggleFilter,

}) => {
  const [state, setState] = useState(false);
  const { overlayState, toggleOverlay } = useToggle();
  const rotatation      = useRotation(); 

  const navigate = useNavigate();

  const isMobile = useBreak("md_dn");

  const here = useLocation().pathname;

  const isIsometry = here.includes("isometry");

  const type = getFocus(_bootstrap, "type");

  const names = getFocus(_bootstrap, "projectnames");

  const language = useAtom(current_language)[0];

  const params = useGet(params_query);

  const setActiveProject = useAtom(currentActiveProject)[1];
const iFrameEnabled = isIframeMode()
  const frame = getIsoData("activeframe");
  const frames = getIsoData("frames");
  const index = getIsoData("snapindex");

  const setIndex = setIsoData("snapindex");
  const setFrame = setIsoData("activeframe");

  const lowQualityPercent = getLowIsoData("percent");
  const lowQualityConfig = getLowIsoData("config");

  const isStatus = true;

  const isOverview = type === "poly" && pin === 0;

  const showButton = [
    "list",
    "compare",
    "favorites",
    "gallery",
    "downloads",
  ].some((i) => here.includes(i));

  const showControls =
    !rotatation.turnBuilding &&
    isIsometry &&
    !rotatation.rotatemode &&
    lowQualityPercent == 100 &&
    lowQualityConfig?.IMAGE_SNAPFRAMES?.length > 1;
    
  const showRotateButton = rotatation.turnBuilding;

  const sharedButtonProps = {
    clr,
    pin,
    type,
    isMobile,
    isIsometry,
    showButton,
  };

  const handleToggleSelect = () => {
    toggleOverlay('selectFunction')
  };

  const handlePropertyToggle = () => {
     toggleOverlay('property')
  };

  const handleOverviewNavigation = () => {

    setActiveProject("");

    navigate(
      type === "mono"
        ? `/${language}/isometry${params.length ? params : ""}`
        : `/${language + names[language][0].path}${
            params.length ? params : ""
          }`
    );
  };

  const renderSelectButton = () => {
    if (rotatation.turnBuilding && !isMobile) return null;

    return (
      <ArrowButton
        variant={"primary"}
        clr={clr}
        padding={"18px"}
        onClick={handleToggleSelect}
      >
        <span
          style={{
            fontSize: "22px",
            display: "inline-flex",
          }}
        >
          <Icon
            icon="ellipsisvertical"
            color={clr.primary_text}
            isFaIcon={true}
            size="sm"
            wrap={{
              transform: overlayState.selectFunction 
                ? "rotate(90deg)"
                : "rotate(0deg)",
            }}
          />
        </span>
      </ArrowButton>
    );
  };

  const renderRotationButton = () => (
    <EusButton
      {...sharedButtonProps}
      onClick={rotatation.handleRotate}
      variant={"primary"}
      icon={true}
      iconName={rotatation.isrotate ? "pause" : "play"}
      isFaIcon={true}
      buttonlabel={false}
      otherText={rotatation.isrotate ? "Stop rotation" : "Start rotation"}
      iconSize={"xl"}
    />
  );

  const renderModelButton = () => {
    if (isIsometry) {
      return (
        <EusButton
          {...sharedButtonProps}
          active={here.includes("list")}
          onClick={clickList}
          variant={"primary"}
          iconName={"list"}
          icon={true}
          buttonText={"Boligliste"}
          buttonlabel={true}
          iconSize={"xl"}
          isFaIcon={true}
        />
      );
    }

    return (
      <EusButton
        {...sharedButtonProps}
        iconName={isOverview ? "modelover" : "model"}
        icon={true}
        buttonlabel={!isOverview}
        otherText={isOverview ? "Oversigtskort" : undefined}
        buttonText={!isOverview ? "isometri" : undefined}
        onClick={clickModel}
        variant={"primary"}
        iconSize={isOverview ? "xl" : "25"}
        isFaIcon={!isOverview}
        active={true}
      />
    );
  };

  const renderFilterButton = () => {
    if (isMobile) return null;

    return (
      <EusButton
        {...sharedButtonProps}
        iconName={"filters"}
        icon={true}
        buttonText={"Anvendfilter"}
        buttonlabel={true}
        onClick={toggleFilter}
        variant={"primary"}
        iconSize={"xl"}
        isFaIcon={true}
      />
    );
  };

  const renderPropertyButton = () => {
    if (type !== "poly") return null;

    return (
      <>
        <ETStyledButton
          variant={"primary"}
          pin={pin}
          clr={clr}
          showButton={showButton}
          onClick={handlePropertyToggle}
        >
          <Icon
            icon="new_building_icon"
            size="lg"
            color={pin > 0 || showButton ? "#fff" : clr?.primary_text}
            isFaIcon={true}
          />

          <div
            className="eus-button-2"
            style={{ color: clr?.primary_text }}
          >
            Skift ejendom
          </div>
        </ETStyledButton>
      {
        overlayState.property && <ShiftProperty />
      }
      </>
    );
  };

  const renderStatusButton = () => {
    if (!(type === "mono" || (type === "poly" && pin !== 0))) {
      return null;
    }

    return (
      <ETStyledButton
        variant={isMobile ? "secondary" : "primary"}
        isStatus={isStatus}
        pin={pin}
        clr={clr}
        onClick={() => isMobile && setState(!state)}
        onMouseEnter={() => !isMobile && setState(true)}
        onMouseLeave={() => !isMobile && setState(false)}
      >
        <Status
          pin={pin}
          state={state}
          setState={setState}
          isMobile={isMobile}
          percent={lowQualityPercent}
        />
      </ETStyledButton>
    );
  };

  const renderOverviewButton = () => {
    if (!(type === "poly" && pin > 0)) return null;

    return (
      <EusButton
        {...sharedButtonProps}
        iconName={"modelover"}
        icon={true}
        buttonlabel={false}
        otherText={"Oversigtskort"}
        onClick={handleOverviewNavigation}
        variant={"primary"}
        iconSize={"xl"}
        isFaIcon={false}
        active={true}
      />
    );
  };

  return (
    <FullWidth
     iFrameEnabled = {iFrameEnabled}
      isMobile={isMobile}
      left={left}
      right={right}
      nav={nav}
      clr={clr}
      isBgTrue={true}
    >
      <FlexBox clr={clr} isIsometry={isIsometry}>
        <CommoIframenMenus />
        {isMobile ? (
          <>
            {!rotatation.rotatemode && (
              <Box sx={{ marginRight: "8px" }}>
                {renderSelectButton()}

                <SelectFunction />
              </Box>
            )}

            {showRotateButton ? (
              renderRotationButton()
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: isIsometry
                      ? "flex-start"
                      : "space-between",
                    gap: "8px",
                    position: "relative",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {renderModelButton()}
                </Box>

                {showControls && (
                  <Box>
                    <Section width="none">
                      <Controls
                        frame={frame}
                        setFrame={setFrame}
                        config={lowQualityConfig}
                        frames={frames}
                        index={index}
                        setIndex={setIndex}
                      />
                    </Section>
                  </Box>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Box
              sx={{
                width: !isIsometry ? "100%" : "auto",
                display: "flex",
                justifyContent: !isIsometry
                  ? "flex-start"
                  : "space-between",
                gap: "16px",
                position: "relative",
              }}
            >
              {isIsometry && renderSelectButton()}
             
              {overlayState.selectFunction && (
                <SelectFunction
                />
              )}

              {showRotateButton ? (
                renderRotationButton()
              ) : (
                <>
                  {renderModelButton()}

                  {renderFilterButton()}

                  {renderOverviewButton()}

                  {renderPropertyButton()}

                  {renderStatusButton()}
                </>
              )}
            </Box>

            {showControls && (
              <Box>
                <Section width="none">
                  <Controls
                    frame={frame}
                    setFrame={setFrame}
                    config={lowQualityConfig}
                    frames={frames}
                    index={index}
                    setIndex={setIndex}
                  />
                </Section>
              </Box>
            )}
          </>
        )}
      </FlexBox>

      <PoweredBy
        clr="#000"
        padding={isMobile ? "0px 0 16px 0" : "0px 0 8px 0"}
      />
    </FullWidth>
  );
};